
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Franz E., 81 ans, décédé le 13 avril 2020</b>
    <br />
    <br />
    <i>Sa femme déclare:</i>
    <br />
    <p>
  «Nous ressentons encore de la colère et de la rage. Mon mari est sorti
  beaucoup trop tôt de l’hôpital. Trois jours après être rentré à la maison, son
  état de santé s’est aggravé et il a dû à nouveau être hospitalisé, mais en
  urgence, cette fois-ci. Entre-temps, j’ai été infectée moi aussi. J’étais
  malade, à l’isolement chez moi, pendant que lui était sous aide respiratoire.
  C’est ma famille qui me tenait au courant de son évolution. Il s’est battu
  pendant 19 jours. Les médecins ont tout tenté, avant de se rendre compte qu’il
  n’y avait plus rien à faire. J’ai eu une demi-heure seulement pour me préparer
  à lui dire au revoir par téléphone. J'avais pris des notes pour ne rien
  oublier. Le médecin m’a appelée. Il m’a dit qu’il avait fermé la porte de sa
  chambre, qu’il était seul avec mon mari et qu’il maintenait le combiné près de
  son oreille. J’étais la seule à pouvoir parler. Lui ne pouvait rien, il était
  dans un coma artificiel. C’était horrible. J’ai eu toutefois le sentiment
  d’avoir pu lui dire ce que j’avais à dire. Après cela, je n’ai pas quitté ma
  maison pendant deux mois. Je n’avais pas la force de le faire. Je ne voulais
  rencontrer personne. Je n’aurais pas su quoi dire. Je n’avais rien à dire.
  J’ai été beaucoup soutenue durant cette période. J’ai la chance d’avoir
  d’adorables enfants qui ont pris régulièrement de mes nouvelles par téléphone.
  Mes voisins me laissaient de la soupe sur le palier de ma maison. Je ne
  comprends pas les personnes qui critiquent les mesures sanitaires anti-Covid.
  Nous devons nous protéger contre ce virus. Nous devons aussi protéger les
  autres. J’ai l’impression qu’il faut malheureusement connaître personnellement
  le drame du Covid pour prendre conscience du danger.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;